import * as mutationType from "../mutation_types";

const state = {
  list: []
};

const getters = {
  list: state => state.list || []
};

const actions = {
  getGoals({ commit }, filter) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(`/api/goals`, filter)
        .then(res => {
          commit(mutationType.SET_GOALS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveGoal({ commit }, goal) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/goals`, goal)
        .then(res => {
          commit(mutationType.SET_GOAL, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteGoal({ commit }, goal) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(`/api/goals/${goal.id}`)
        .then(() => {
          commit(mutationType.DELETE_GOAL, goal);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  reopenGoal({ commit }, goal) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/goals/${goal.id}/reopen`)
        .then(() => {
          commit(mutationType.REOPEN_GOAL, goal);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveGoalNote({ commit }, note) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(`/api/goals/${note.parentId}/notes`, note)
        .then(res => {
          commit(mutationType.SET_GOAL_NOTE, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteGoalNote({ commit }, note) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(`/api/goals/${note.parentId}/notes/${note.id}`)
        .then(() => {
          commit(mutationType.DELETE_GOAL_NOTE, note);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveGoalTask({ commit }, task) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(`/api/goals/${task.goalId}/tasks`, task)
        .then(res => {
          commit(mutationType.SET_GOAL_TASK, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  completeGoalTask({ commit }, task) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/goals/${task.goalId}/tasks/${task.id}/complete`)
        .then(res => {
          commit(mutationType.SET_GOAL_TASK, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  reopenGoalTask({ commit }, task) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/goals/${task.goalId}/tasks/${task.id}/reopen`)
        .then(() => {
          commit(mutationType.REOPEN_GOAL_TASK, task);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteGoalTask({ commit }, task) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(`/api/goals/${task.goalId}/tasks/${task.id}`)
        .then(() => {
          commit(mutationType.DELETE_GOAL_TASK, task);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [mutationType.SET_GOALS](state, list) {
    state.list = list;
  },
  [mutationType.SET_GOAL](state, goal) {
    let index = state.list.findIndex(cv => cv.id == goal.id);
    if (index >= 0) {
      state.list[index] = Object.assign(state.list[index], goal);
    } else {
      state.list.push(goal);
    }
  },
  [mutationType.DELETE_GOAL](state, goal) {
    let index = state.list.findIndex(cv => cv.id == goal.id);
    if (index >= 0) {
      state.list.splice(index, 1);
    }
  },
  [mutationType.REOPEN_GOAL](state, goal) {
    let index = state.list.findIndex(cv => cv.id == goal.id);
    if (index >= 0) {
      this._vm.$set(state.list[index], "completeDate", null);
      this._vm.$set(state.list[index], "percentComplete", null);
      this._vm.$set(state.list[index], "statusId", 1);
    }
  },
  [mutationType.SET_GOAL_NOTE](state, note) {
    let gIndex = state.list.findIndex(cv => cv.id == note.parentId);
    if (gIndex >= 0) {
      let noteIndex = state.list[gIndex].notes.findIndex(
        cv => cv.id == note.id
      );
      if (noteIndex >= 0) {
        state.list[gIndex].notes[noteIndex] = Object.assign(
          state.list[gIndex].notes[noteIndex],
          note
        );
      } else {
        state.list[gIndex].notes.push(note);
      }
    }
  },
  [mutationType.DELETE_GOAL_NOTE](state, note) {
    let gIndex = state.list.findIndex(cv => cv.id == note.parentId);
    if (gIndex >= 0) {
      let noteIndex = state.list[gIndex].notes.findIndex(
        cv => cv.id == note.id
      );
      if (noteIndex >= 0) {
        state.list[gIndex].notes.splice(noteIndex, 1);
      }
    }
  },
  [mutationType.SET_GOAL_TASK](state, task) {
    let gIndex = state.list.findIndex(cv => cv.id == task.goalId);
    if (gIndex >= 0) {
      let taskIndex = state.list[gIndex].tasks.findIndex(
        cv => cv.id == task.id
      );
      if (taskIndex >= 0) {
        state.list[gIndex].tasks[taskIndex] = Object.assign(
          state.list[gIndex].tasks[taskIndex],
          task
        );
      } else {
        state.list[gIndex].tasks.push(task);
      }
    }
  },
  [mutationType.REOPEN_GOAL_TASK](state, task) {
    let gIndex = state.list.findIndex(cv => cv.id == task.goalId);
    if (gIndex >= 0) {
      let taskIndex = state.list[gIndex].tasks.findIndex(
        cv => cv.id == task.id
      );
      if (taskIndex >= 0) {
        this._vm.$set(
          state.list[gIndex].tasks[taskIndex],
          "completeDate",
          null
        );
      }
    }
  },
  [mutationType.DELETE_GOAL_TASK](state, task) {
    let gIndex = state.list.findIndex(cv => cv.id == task.goalId);
    if (gIndex >= 0) {
      let taskIndex = state.list[gIndex].tasks.findIndex(
        cv => cv.id == task.id
      );
      if (taskIndex >= 0) {
        state.list[gIndex].tasks.splice(taskIndex, 1);
      }
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
